import { render, staticRenderFns } from "./DoneProjectsControl.vue?vue&type=template&id=681f1936&scoped=true&"
import script from "./DoneProjectsControl.vue?vue&type=script&lang=js&"
export * from "./DoneProjectsControl.vue?vue&type=script&lang=js&"
import style0 from "./DoneProjectsControl.vue?vue&type=style&index=0&id=681f1936&prod&lang=css&"
import style1 from "./DoneProjectsControl.vue?vue&type=style&index=1&id=681f1936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f1936",
  null
  
)

export default component.exports